class DiscountService {
  constructor() {
    this.apiEndpoint = 'https://tc-discountservice-afeza4ayazgkdwd7.westus-01.azurewebsites.net/api/discount';
    this.storageKey = 'guest_discount_code';
    this.init();
  }

  init() {
    const discountCode = this.getDiscountFromUrl();
    const customerId = this.getCustomerId();
    
    if (discountCode) {
      // Check if discount code is valid
      // List is in announcement bar settings
      if (this.isValidDiscountCode(discountCode)) {
        if (customerId) {
          // Customer is logged in, send immediately
          this.sendDiscountToService(discountCode, customerId);
        } else {
          // Customer not logged in, store for later
          this.storePendingDiscount(discountCode);
        }
      } else {
        console.log('Discount code not found in valid codes list');
      }
    }

    // Check for pending discount codes if customer is logged in
    if (customerId) {
      this.processPendingDiscount(customerId);
    }
  }

  getDiscountFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('discount');
  }

  getCustomerId() {
    if (window.customer && window.customer.id) {
      return window.customer.id;
    }

    const customerMeta = document.querySelector('meta[name="customer-id"]');
    if (customerMeta) {
      return customerMeta.getAttribute('content');
    }

    const bodyCustomerId = document.body.getAttribute('data-customer-id');
    if (bodyCustomerId) {
      return bodyCustomerId;
    }

    return null;
  }

  isValidDiscountCode(discountCode) {
    if (window.discountCodes && typeof window.discountCodes === 'object') {
      // Check if discount code exists as a key OR matches the default_code value
      return discountCode in window.discountCodes || 
             discountCode === window.discountCodes['default_code'];
    }
    return false;
  }

  storePendingDiscount(discountCode) {
    try {
      localStorage.setItem(this.storageKey, discountCode);
      console.log('Discount code stored for when customer logs in:', discountCode);
    } catch (error) {
      console.error('Failed to store discount code in localStorage:', error);
    }
  }

  processPendingDiscount(customerId) {
    try {
      const pendingCode = localStorage.getItem(this.storageKey);
      if (pendingCode) {
        // Validate the stored code is still valid
        if (this.isValidDiscountCode(pendingCode)) {
          this.sendDiscountToService(pendingCode, customerId);
          // Remove from localStorage after sending
          localStorage.removeItem(this.storageKey);
          console.log('Processed pending discount code:', pendingCode);
        } else {
          // Remove invalid code from storage
          localStorage.removeItem(this.storageKey);
          console.log('Removed invalid pending discount code:', pendingCode);
        }
      }
    } catch (error) {
      console.error('Failed to process pending discount code:', error);
    }
  }

  _getAuthCode() {
    const chunks = [
      [119, 65, 111, 71, 48, 82, 90, 115, 115, 121, 83, 112, 107, 100, 121, 97],
      [121, 103, 89, 88, 68, 84, 54, 68, 77, 118, 112, 89, 114, 95, 87, 101],
      [90, 75, 51, 95, 84, 54, 50, 53, 52, 121, 88, 55, 65, 122, 70, 117],
      [100, 80, 54, 73, 86, 103, 61, 61]
    ];
    return chunks.map(chunk => 
      chunk.map(code => String.fromCharCode(code)).join('')
    ).join('');
  }

  async sendDiscountToService(discountCode, customerId) {
    try {
      const url = new URL(this.apiEndpoint);
      url.searchParams.append('discount', discountCode);
      url.searchParams.append('id', customerId);
      url.searchParams.append('store', "slt");
      url.searchParams.append('code', this._getAuthCode());

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        // Success
      } else {
        console.error('Discount service error:', response.status, response.statusText);
      }
    } catch (error) {
      console.error('Failed to send discount to service:', error);
    }
  }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  new DiscountService();
});
